import { http } from "./http";
export const operationApi = {
  lookup: (requestKey: string, signal?: AbortSignal) =>
    http.get<unknown>(`/api/operation-receipts/${encodeURIComponent(requestKey)}`, { signal, timeoutMs: 20_000 }),
};
